import React, { useState } from 'react';
import './Mainmodal.scss'
import ReactDOM from 'react-dom';
import lateralHomeModal from '../../assets/home/lateral-homemodal.png';
import imgPopup from '../../assets/home/popup-image.jpeg'
import isotipoHomeModal from '../../assets/navbar/logo.svg';
import { withWidth } from '@material-ui/core';

const Mainmodal = ({ isShowingMain, hideMain }) => {
  const [showMessageMain, setShowMessageMain] = useState(false);

  return (

    isShowingMain ? ReactDOM.createPortal(
      <React.Fragment>
        <div className="modal-overlay2" />
        <div className="modal-wrapper2" aria-modal aria-hidden tabIndex={-1} role="dialog">
          <div class="modal-dialog modal-dialog-centered-main modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="btn-close _btn-close-white" onClick={hideMain} ></button>
                <div class="modal-header-center">
                  <img src={imgPopup} style={{width: '100%'}}/>
                  <div style={{height:'70px', display:'flex', flexDirection:'row', justifyContent:'flex-end', alignItems:'flex-end'}}>
                    <img src={isotipoHomeModal} alt="" class="logo"></img>
                  </div>
                </div>
                {/* <div class="buttons">
                  <button type="button" class="btn btn-secondary btn-sm" onClick={hideMain}>ENTENDIDO &nbsp;</button>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>, document.getElementById('modal')
    ) : null
  )
}
export default Mainmodal;
